export const getVoucher = '/warehouse/voucher/'
export const exportVoucher = '/warehouse/voucher/export'
export const getVoucherBySales = '/warehouse/voucher/'
